import { defineStore } from 'pinia'

export const errorLogStore = defineStore('errorLog', {
  state: () => {
    return {
      logs: [] as string[]
    }
  },
  actions: {
    addErrorLog(log: string) {
      this.logs.push(log)
    },
    clearErrorLog() {
      this.logs.splice(0)
    }
  }
})
